import React from 'react';
import { Button, darken, lighten, Typography, useMediaQuery, useTheme } from '@mui/material';
import { FaOptionIcon } from '@europrocurement/l2d-icons';

export type FlexyPreFilterProps = {
    label: string;
    current: boolean;
    count?: number;
    onClick: () => void;
};

export const FlexyPreFilter: React.FunctionComponent<FlexyPreFilterProps> = function (props) {
    const { label, current, count, onClick } = props;
    const { palette, breakpoints } = useTheme();
    const isLightMode = palette.mode === 'light';
    const downSmBreakpoint = useMediaQuery(breakpoints.down('sm'));

    const filterColor = isLightMode ? palette.secondary.main : palette.secondary.light;
    const filterColorUnselected = isLightMode
        ? lighten(filterColor, 0.35)
        : lighten(filterColor, 0.3);
    const hoverBgColor = isLightMode ? lighten(filterColor, 0.88) : darken(filterColor, 0.65);

    const desktopWrapperStyle = {
        borderBottomStyle: 'solid',
        borderBottomWidth: '2px',
        borderBottomColor: current ? palette.primary.main : 'transparent',
        borderRadius: '8px 8px 0 0',
        padding: '8px',
        display: 'flex',
        gap: '8px',
        transition: 'background-color 0.2s ease',
        '&:hover': {
            backgroundColor: hoverBgColor,
        },
    };
    const desktopLabelStyle = {
        fontSize: '15px',
        fontWeight: current ? '600' : '500',
        lineHeight: '24px',
        color: current ? filterColor : filterColorUnselected,
        whiteSpace: 'nowrap',
    };
    const desktopCounterStyle = {
        fontSize: '13px',
        fontWeight: '500',
        lineHeight: '24px',
        color: palette.text.secondary,
    };

    const mobileBgColor = isLightMode
        ? lighten(palette.primary.main, 0.4)
        : darken(palette.primary.main, 0.5);
    const mobileWrapperStyle = {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '12px',
        width: '100%',
        padding: '0 14px',
        height: '44px',
        backgroundColor: current ? mobileBgColor : 'transparent',
        transition: 'background-color ease-in-out 300ms',
        '&:hover': {
            backgroundColor: mobileBgColor,
        },
    };
    const mobileLabelStyle = {
        color: palette.text.primary,
        fontWeight: '500',
        fontSize: '15px',
        lineHeight: '18px',
        marginRight: 'auto',
    };
    const mobileCounterStyle = {
        fontSize: '13px',
        fontWeight: '500',
        lineHeight: '24px',
        color: palette.text.secondary,
    };

    return (
        <Button
            sx={downSmBreakpoint ? mobileWrapperStyle : desktopWrapperStyle}
            onClick={onClick}
        >
            <Typography
                sx={downSmBreakpoint ? mobileLabelStyle : desktopLabelStyle}
                component="span"
            >
                {label}
            </Typography>
            {count !== undefined && (
                <Typography
                    sx={downSmBreakpoint ? mobileCounterStyle : desktopCounterStyle}
                    component="span"
                >
                    {count}
                </Typography>
            )}
            {current && downSmBreakpoint && <FaOptionIcon icon="check" />}
        </Button>
    );
};
